let currency = "USD";
export const setCurrency = (c) => (currency = c || "USD");

export const fmt = (n, opts = {}) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency, maximumFractionDigits: opts.cents === false ? 0 : 2, minimumFractionDigits: opts.cents === false ? 0 : 2 }).format(Number(n) || 0);

export const fmt0 = (n) => fmt(n, { cents: false });
export const pct = (n) => `${(Number(n) || 0).toFixed(1)}%`;

export const monthKey = (d) => (d || "").slice(0, 7);
export const monthLabel = (k, short = false) => {
  if (!k) return "";
  const [y, m] = k.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString("en-US", { month: short ? "short" : "long", year: short ? "2-digit" : "numeric" });
};
export const dateLabel = (d) => {
  if (!d) return "";
  const [y, m, day] = d.split("-").map(Number);
  return new Date(y, m - 1, day).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};
export const toISO = (dt) => `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`;
export const parseISO = (s) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};
export const addDays = (s, n) => {
  const d = parseISO(s);
  d.setDate(d.getDate() + n);
  return toISO(d);
};
export const daysBetween = (a, b) => Math.round((parseISO(b) - parseISO(a)) / 86400000);
export const today = () => toISO(new Date());
export const uid = () => Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4);
export const rateLabel = (r) => `$${Number(r || 0).toFixed(3).replace(/0$/, "")}`;
export const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
